<template>
  <v-chip-group
    v-model="activeRoom"
    mandatory
    center-active
    active-class="font-weight-medium"
  >
    <v-chip
      v-for="room in rooms"
      :key="room.id"
      :value="room.id"
      filter
      :filter-icon="icons.activeRoom"
      color="accent"
      class="mt-0"
      :ripple="false"
    >
      {{ room.name }}
    </v-chip>
  </v-chip-group>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      rooms: {
        required: true,
        type: Array,
      },
    },

    computed: {
      activeRoom: {
        get () {
          return this.$store.state.dashboard.room
        },
        set (v) {
          this.$store.commit('dashboard/room', v)
        },
      },
    },
  }
</script>
